import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { Subsidiary } from "../../http/subsidiaries/types";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import FormFieldsContainer from "../ui/FormFieldsContainer";
import Input from "../ui/Input";

export interface SubsidiaryIsoCodeFormBody {
  countryIsoCodeAlpha2: string;
}

type SubsidiaryIsoCodeFormProps = {
  onSubmit: (form: SubsidiaryIsoCodeFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
  subsidiary: Subsidiary;
};

const SetSubsidiaryIsoCodeForm: FC<SubsidiaryIsoCodeFormProps> = ({
  onSubmit,
  isDisabled,
  isLoading,
  subsidiary,
}: SubsidiaryIsoCodeFormProps) => {
  const i18n = useI18n();

  return (
    <Form<SubsidiaryIsoCodeFormBody> submitText={i18n.t.common.save} disabled={isDisabled} onSubmit={() => onSubmit}>
      {({ register, formState: { errors } }) => {
        return (
          <FormFieldsContainer>
            <Input title={i18n.t.subsidiaries.singular} value={subsidiary.name} disabled />
            <FormField label={i18n.t.common.countryIsoCode} error={errors.countryIsoCodeAlpha2}>
              {({ labelId, isInvalid }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  maxLength={2}
                  disabled={isDisabled || isLoading}
                  forceUpper
                  {...register("countryIsoCodeAlpha2", {
                    required: true,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default SetSubsidiaryIsoCodeForm;
